import { IsPremiumConsumerUser, IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
import isIndexedPath from 'owa-url/lib/isIndexedPath';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isBusiness } from 'owa-session-store';

/**
 * TODO: Deprecate use of V1 from
 * owa-left-rail module and update references
 */
export function isLeftRailVisibleV2() {
    return isCloudCacheScenario() || isMultiAccountScenario();
}

/**
 * Check if its a MultiAccount scenario
 */
export function isMultiAccountScenario() {
    return isFeatureEnabled('mail-oneView') && isBusiness();
}

/**
 * Check if its a Cloud cache scenario
 */
function isCloudCacheScenario() {
    return (
        isFeatureEnabled('auth-cloudCache') &&
        (IsPremiumConsumerUser() || IsShadowMailboxUser()) &&
        isIndexedPath(window?.location ? window.location.pathname : null)
    );
}
